<div class="container-fluid">
  <div class="row">

    <div class="col-12 text-center py-3 bg-primary text-white">
      CradleResident© 2024 - 2025 - Todos los derechos reservados.
    </div>
    
  </div>
</div>